const ID = 'quote';

export default ID;
